var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", [_vm._v(_vm._s(_vm.labels.burgStaat.objectName))]),
      _vm._v(" "),
      _c("select-input", {
        attrs: {
          id: "pLidBurgstand",
          label: "Burgerlijke staat",
          "is-dirty":
            _vm.gezin.burgStaat.burgstaat != _vm.cache.burgStaat.burgstaat,
          "select-values": _vm.burgStanden,
          info: _vm.infoForBurgstaat("burgstaat"),
          "is-disabled": _vm.disabledFieldsMap.burgStaat.burgstaat
        },
        on: {
          input: function($event) {
            _vm.isBurgStaatDirty = true
          },
          close: _vm.updateHasPartner
        },
        model: {
          value: _vm.gezin.burgStaat.burgstaat,
          callback: function($$v) {
            _vm.$set(_vm.gezin.burgStaat, "burgstaat", $$v)
          },
          expression: "gezin.burgStaat.burgstaat"
        }
      }),
      _vm._v(" "),
      _c("date-input", {
        attrs: {
          id: "burgStaatRefDate",
          label: _vm.labels.burgStaat.burgstaatDatum,
          placeholder: "Referentiedatum voor deze burgerlijke staat",
          "is-dirty": false,
          "is-invalid": _vm.$v.gezin.burgStaat.burgstaatDatum.$invalid
        },
        model: {
          value: _vm.gezin.burgStaat.burgstaatDatum,
          callback: function($$v) {
            _vm.$set(_vm.gezin.burgStaat, "burgstaatDatum", $$v)
          },
          expression: "gezin.burgStaat.burgstaatDatum"
        }
      }),
      _vm._v(" "),
      _c("date-input", {
        attrs: {
          id: "huwelijksdatumRefDate",
          label: _vm.labels.burgStaat.huwelijksdatum,
          placeholder: "Huwelijksdatum / datum wettelijk samenwonend",
          "is-dirty": false,
          "is-invalid": _vm.$v.gezin.burgStaat.huwelijksdatum.$invalid
        },
        model: {
          value: _vm.gezin.burgStaat.huwelijksdatum,
          callback: function($$v) {
            _vm.$set(_vm.gezin.burgStaat, "huwelijksdatum", $$v)
          },
          expression: "gezin.burgStaat.huwelijksdatum"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("h5", [_vm._v(_vm._s(_vm.labels.partner.objectName))]),
          _vm._v(" "),
          _c("text-input", {
            attrs: {
              id: "pLidPartnerNaam",
              label: _vm.labels.partner.naam,
              "is-dirty": _vm.partner.naam != _vm.cache.partner.naam,
              "validation-object": _vm.$v.gezin.partner.naam,
              info: _vm.infoForPartner("naam"),
              "is-disabled": _vm.disabledFieldsMap.partner.naam
            },
            on: { input: _vm.onPartnerUpdate },
            model: {
              value: _vm.$v.gezin.partner.naam.$model,
              callback: function($$v) {
                _vm.$set(
                  _vm.$v.gezin.partner.naam,
                  "$model",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "$v.gezin.partner.naam.$model"
            }
          }),
          _vm._v(" "),
          _c("text-input", {
            attrs: {
              id: "pLidPartnerVoornaam",
              label: _vm.labels.partner.voornaam,
              "is-dirty": _vm.partner.voornaam != _vm.cache.partner.voornaam,
              "validation-object": _vm.$v.gezin.partner.voornaam,
              info: _vm.infoForPartner("voornaam"),
              "is-disabled": _vm.disabledFieldsMap.partner.voornaam
            },
            on: { input: _vm.onPartnerUpdate },
            model: {
              value: _vm.$v.gezin.partner.voornaam.$model,
              callback: function($$v) {
                _vm.$set(
                  _vm.$v.gezin.partner.voornaam,
                  "$model",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "$v.gezin.partner.voornaam.$model"
            }
          }),
          _vm._v(" "),
          !_vm.hiddenFieldsMap.partner.nationaliteit
            ? _c("nationality-input", {
                attrs: {
                  id: "partnerNatio",
                  label: _vm.labels.partner.nationaliteit,
                  "is-dirty-natio": _vm.$v.gezin.partner.nationaliteit.$dirty,
                  "show-delete": false,
                  info: _vm.infoForPartner("nationaliteit"),
                  "is-disabled":
                    _vm.disabledFieldsMap.partner.nationaliteit.nationaliteit,
                  "has-type": false
                },
                model: {
                  value: _vm.$v.gezin.partner.nationaliteit.$model,
                  callback: function($$v) {
                    _vm.$set(_vm.$v.gezin.partner.nationaliteit, "$model", $$v)
                  },
                  expression: "$v.gezin.partner.nationaliteit.$model"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("date-input", {
            attrs: {
              id: "pLidPartnerGeboortedatum",
              label: _vm.labels.partner.geboortedatum,
              "is-dirty":
                _vm.partner.geboortedatum != _vm.cache.partner.geboortedatum,
              required: _vm.$v.gezin.partner.geboortedatum.hasOwnProperty(
                "required"
              ),
              info: _vm.infoForPartner("geboortedatum"),
              "is-disabled": _vm.disabledFieldsMap.partner.geboortedatum
            },
            on: { input: _vm.onPartnerUpdate },
            model: {
              value: _vm.partner.geboortedatum,
              callback: function($$v) {
                _vm.$set(_vm.partner, "geboortedatum", $$v)
              },
              expression: "partner.geboortedatum"
            }
          }),
          _vm._v(" "),
          !_vm.hiddenFieldsMap.partner.geboorteplaats
            ? _c("text-input", {
                attrs: {
                  id: "pLidPartnerGeboorteplaats",
                  label: _vm.labels.partner.geboorteplaats,
                  "is-dirty":
                    _vm.partner.geboorteplaats !=
                    _vm.cache.partner.geboorteplaats,
                  "validation-object": _vm.$v.gezin.partner.geboorteplaats,
                  info: _vm.infoForPartner("geboorteplaats"),
                  "is-disabled": _vm.disabledFieldsMap.partner.geboorteplaats
                },
                on: { input: _vm.onPartnerUpdate },
                model: {
                  value: _vm.$v.gezin.partner.geboorteplaats.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.gezin.partner.geboorteplaats,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.gezin.partner.geboorteplaats.$model"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("yes-no-input", {
            attrs: {
              id: "pLidPartnerMindervalide",
              name: "PartnerMindervalideRadio",
              label: _vm.labels.partner.mindervalide,
              info: _vm.infoForPartner("mindervalide"),
              "is-disabled": _vm.disabledFieldsMap.partner.mindervalide,
              "is-dirty":
                _vm.partner.mindervalide != _vm.cache.partner.mindervalide
            },
            model: {
              value: _vm.$v.gezin.partner.mindervalide.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.gezin.partner.mindervalide, "$model", $$v)
              },
              expression: "$v.gezin.partner.mindervalide.$model"
            }
          }),
          _vm._v(" "),
          _c("yes-no-input", {
            attrs: {
              id: "pLidPartnerTenLaste",
              name: "partnerTenLasteRadio",
              label: _vm.labels.partner.tenLaste,
              info: _vm.infoForPartner("tenLaste"),
              "is-disabled": _vm.disabledFieldsMap.partner.tenLaste,
              "is-dirty": _vm.partner.tenLaste != _vm.cache.partner.tenLaste
            },
            model: {
              value: _vm.$v.gezin.partner.tenLaste.$model,
              callback: function($$v) {
                _vm.$set(_vm.$v.gezin.partner.tenLaste, "$model", $$v)
              },
              expression: "$v.gezin.partner.tenLaste.$model"
            }
          }),
          _vm._v(" "),
          _c("text-input", {
            attrs: {
              id: "pLidPartnerBeroep",
              label: _vm.labels.partner.beroep,
              "is-dirty": _vm.partner.beroep != _vm.cache.partner.beroep,
              "validation-object": _vm.$v.gezin.partner.beroep,
              info: _vm.infoForPartner("beroep"),
              "is-disabled": _vm.disabledFieldsMap.partner.beroep
            },
            on: { input: _vm.onPartnerUpdate },
            model: {
              value: _vm.$v.gezin.partner.beroep.$model,
              callback: function($$v) {
                _vm.$set(
                  _vm.$v.gezin.partner.beroep,
                  "$model",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "$v.gezin.partner.beroep.$model"
            }
          }),
          _vm._v(" "),
          !_vm.hiddenFieldsMap.partner.werkgever
            ? _c("text-input", {
                attrs: {
                  id: "pLidPartnerWerkgever",
                  label: _vm.labels.partner.werkgever,
                  "is-dirty":
                    _vm.partner.werkgever !== _vm.cache.partner.werkgever,
                  "validation-object": _vm.$v.gezin.partner.werkgever,
                  info: _vm.infoForPartner("werkgever"),
                  "is-disabled": _vm.disabledFieldsMap.partner.werkgever
                },
                on: { input: _vm.onPartnerUpdate },
                model: {
                  value: _vm.$v.gezin.partner.werkgever.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.gezin.partner.werkgever,
                      "$model",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "$v.gezin.partner.werkgever.$model"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("date-input", {
            attrs: {
              id: "pLidPartnerOverlijdensdatum",
              required: _vm.$v.gezin.partner.partnOverlijdensdatum.hasOwnProperty(
                "required"
              ),
              label: _vm.labels.partner.overlijdensdatum,
              info: _vm.infoForPartner("overlijdensdatum"),
              "is-disabled": _vm.disabledFieldsMap.partner.overlijdensdatum,
              "is-dirty":
                _vm.partner.partnOverlijdensdatum !=
                _vm.cache.partner.partnOverlijdensdatum
            },
            on: { input: _vm.onPartnerUpdate },
            model: {
              value: _vm.$v.gezin.partner.partnOverlijdensdatum.$model,
              callback: function($$v) {
                _vm.$set(
                  _vm.$v.gezin.partner.partnOverlijdensdatum,
                  "$model",
                  typeof $$v === "string" ? $$v.trim() : $$v
                )
              },
              expression: "$v.gezin.partner.partnOverlijdensdatum.$model"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.gezin.gezinsleden.length == 1
        ? _c("h5", [
            _vm._v(
              "\n    " +
                _vm._s(_vm.labels.gezinsleden.objectName.singular) +
                "\n  "
            )
          ])
        : _c("h5", [_vm._v(_vm._s(_vm.labels.gezinsleden.objectName.plural))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-responsive d-flex justify-content-center" },
        [
          _vm.gezin.gezinsleden.length != 0
            ? _c("table", { staticClass: "table table-striped card-title" }, [
                _c("thead", [
                  _c("tr", [
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.verwantschap))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.naam))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.voornaam))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.geboortedatum))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.tenLaste))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.nietMeerTenLaste))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.mindervalide))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.zorgbehoevend))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [
                      _vm._v(_vm._s(_vm.labels.gezinsleden.overlijdensdatum))
                    ]),
                    _vm._v(" "),
                    _c("th", { attrs: { scope: "col" } }, [_vm._v("Acties")])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.gezin.gezinsleden, function(gezinslid, index) {
                    return _c(
                      "tr",
                      { key: "tr-gezinslid-" + parseInt(index) },
                      [
                        gezinslid.verwantschap
                          ? _c("td", [_vm._v(_vm._s(gezinslid.verwantschap))])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.verwantschap == ""
                          ? _c("td", [_vm._v("?")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.naam))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.voornaam))]),
                        _vm._v(" "),
                        _c("td", [_vm._v(_vm._s(gezinslid.geboortedatum))]),
                        _vm._v(" "),
                        gezinslid.tenLaste
                          ? _c("td", [_vm._v("Ja")])
                          : _vm._e(),
                        _vm._v(" "),
                        !gezinslid.tenLaste
                          ? _c("td", [_vm._v("Nee")])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.nietMeerTenLaste
                          ? _c("td", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(gezinslid.nietMeerTenLaste) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.nietMeerTenLaste == null ||
                        gezinslid.nietMeerTenLaste == ""
                          ? _c("td", [_vm._v("\n            /\n          ")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(gezinslid.mindervalide ? "Ja" : "Nee"))
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm._v(_vm._s(gezinslid.zorgbehoevend ? "Ja" : "Nee"))
                        ]),
                        _vm._v(" "),
                        gezinslid.overlijdensdatum != null
                          ? _c("td", [
                              _vm._v(
                                "\n            " +
                                  _vm._s(gezinslid.overlijdensdatum) +
                                  "\n          "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        gezinslid.overlijdensdatum == null
                          ? _c("td", [_vm._v("/")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-left" },
                          [
                            _c("edit-button", {
                              on: {
                                click: function($event) {
                                  return _vm.editGezinslid(index)
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c("delete-button", {
                              on: {
                                click: function($event) {
                                  return _vm.deleteGezinslid(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  0
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.gezin.gezinsleden.length == 0
            ? _c("h5", [
                _vm._v(
                  "\n      Geen gezinsleden. U kan gezinsleden toevoegen met onderstaande knop.\n    "
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "text-center" }, [
        _c(
          "button",
          {
            directives: [
              {
                name: "tooltip",
                rawName: "v-tooltip",
                value: "Gezinslid toevoegen",
                expression: "'Gezinslid toevoegen'"
              }
            ],
            staticClass: "btn btn-success btn-sm",
            attrs: {
              disabled: _vm.isCurrentlyEditingGezinslid,
              type: "button"
            },
            on: {
              click: function($event) {
                return _vm.addGezinslid()
              }
            }
          },
          [_c("font-awesome-icon", { attrs: { icon: ["fad", "user-plus"] } })],
          1
        )
      ]),
      _vm._v(" "),
      _vm.isCurrentlyEditingGezinslid
        ? _c(
            "div",
            [
              _vm.isNewGezinslid
                ? _c("h5", [_vm._v("Nieuw gezinslid toevoegen")])
                : _c("h5", [_vm._v("Bewerk gezinslid")]),
              _vm._v(" "),
              _c("select-input", {
                attrs: {
                  id: "pLidEditingVerwantschap",
                  label: _vm.labels.gezinsleden.verwantschap,
                  "is-dirty":
                    _vm.$v.currentlyEditingGezinslid.verwantschap.$dirty,
                  required: _vm.$v.currentlyEditingGezinslid.verwantschap.hasOwnProperty(
                    "required"
                  ),
                  "select-values": _vm.verwantschappen,
                  info: _vm.infoForGezinsleden("verwantschap"),
                  "is-disabled": _vm.disabledFieldsMap.gezinsleden.verwantschap
                },
                model: {
                  value: _vm.$v.currentlyEditingGezinslid.verwantschap.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.currentlyEditingGezinslid.verwantschap,
                      "$model",
                      $$v
                    )
                  },
                  expression: "$v.currentlyEditingGezinslid.verwantschap.$model"
                }
              }),
              _vm._v(" "),
              _c("text-input", {
                attrs: {
                  id: "pLidEditingGezezinslidNaam",
                  label: _vm.labels.gezinsleden.naam,
                  "is-dirty": _vm.$v.currentlyEditingGezinslid.naam.$dirty,
                  info: _vm.infoForGezinsleden("naam"),
                  "is-disabled": _vm.disabledFieldsMap.gezinsleden.naam,
                  "validation-object": _vm.$v.currentlyEditingGezinslid.naam
                },
                model: {
                  value: _vm.$v.currentlyEditingGezinslid.naam.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.currentlyEditingGezinslid.naam,
                      "$model",
                      $$v
                    )
                  },
                  expression: "$v.currentlyEditingGezinslid.naam.$model"
                }
              }),
              _vm._v(" "),
              _c("text-input", {
                attrs: {
                  id: "pLidEditingVoornaam",
                  label: _vm.labels.gezinsleden.voornaam,
                  "is-dirty": _vm.$v.currentlyEditingGezinslid.voornaam.$dirty,
                  info: _vm.infoForGezinsleden("voornaam"),
                  "is-disabled": _vm.disabledFieldsMap.gezinsleden.voornaam,
                  "validation-object": _vm.$v.currentlyEditingGezinslid.voornaam
                },
                model: {
                  value: _vm.$v.currentlyEditingGezinslid.voornaam.$model,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.$v.currentlyEditingGezinslid.voornaam,
                      "$model",
                      $$v
                    )
                  },
                  expression: "$v.currentlyEditingGezinslid.voornaam.$model"
                }
              }),
              _vm._v(" "),
              _c("date-input", {
                attrs: {
                  id: "pLidEditingGeboortedatum",
                  required: _vm.$v.currentlyEditingGezinslid.geboortedatum.hasOwnProperty(
                    "required"
                  ),
                  label: _vm.labels.gezinsleden.geboortedatum,
                  info: _vm.infoForGezinsleden("geboortedatum"),
                  "is-disabled":
                    _vm.disabledFieldsMap.gezinsleden.geboortedatum,
                  "is-dirty":
                    _vm.$v.currentlyEditingGezinslid.geboortedatum.$dirty
                },
                model: {
                  value: _vm.currentlyEditingGezinslid.geboortedatum,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentlyEditingGezinslid,
                      "geboortedatum",
                      $$v
                    )
                  },
                  expression: "currentlyEditingGezinslid.geboortedatum"
                }
              }),
              _vm._v(" "),
              _c("yes-no-input", {
                attrs: {
                  name: "curGezinslidMindervalideRadio",
                  id: "pLidEditingMindervalide",
                  label: _vm.labels.gezinsleden.mindervalide,
                  info: _vm.infoForGezinsleden("mindervalide"),
                  "is-disabled": _vm.disabledFieldsMap.gezinsleden.mindervalide,
                  "is-dirty":
                    _vm.$v.currentlyEditingGezinslid.mindervalide.$dirty
                },
                model: {
                  value: _vm.currentlyEditingGezinslid.mindervalide,
                  callback: function($$v) {
                    _vm.$set(_vm.currentlyEditingGezinslid, "mindervalide", $$v)
                  },
                  expression: "currentlyEditingGezinslid.mindervalide"
                }
              }),
              _vm._v(" "),
              _c("yes-no-input", {
                attrs: {
                  name: "curGezinslidZorgbehoevendRadio",
                  id: "pLidEditingZorgbehoevend",
                  label: _vm.labels.gezinsleden.zorgbehoevend,
                  info: _vm.infoForGezinsleden("zorgbehoevend"),
                  "is-disabled":
                    _vm.disabledFieldsMap.gezinsleden.zorgbehoevend,
                  "is-dirty":
                    _vm.$v.currentlyEditingGezinslid.zorgbehoevend.$dirty
                },
                model: {
                  value: _vm.currentlyEditingGezinslid.zorgbehoevend,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentlyEditingGezinslid,
                      "zorgbehoevend",
                      $$v
                    )
                  },
                  expression: "currentlyEditingGezinslid.zorgbehoevend"
                }
              }),
              _vm._v(" "),
              _c("yes-no-input", {
                attrs: {
                  id: "pLidEditingTenLaste",
                  name: "curGezinslidTenLasteRadio",
                  label: _vm.labels.gezinsleden.tenLaste,
                  info: _vm.infoForGezinsleden("tenLaste"),
                  "is-disabled": _vm.disabledFieldsMap.gezinsleden.tenLaste,
                  "is-dirty": _vm.$v.currentlyEditingGezinslid.tenLaste.$dirty
                },
                model: {
                  value: _vm.currentlyEditingGezinslid.tenLaste,
                  callback: function($$v) {
                    _vm.$set(_vm.currentlyEditingGezinslid, "tenLaste", $$v)
                  },
                  expression: "currentlyEditingGezinslid.tenLaste"
                }
              }),
              _vm._v(" "),
              _vm.currentlyEditingGezinslid.tenLaste == false
                ? _c("date-input", {
                    attrs: {
                      required: _vm.$v.currentlyEditingGezinslid.nietMeerTenLaste.hasOwnProperty(
                        "required"
                      ),
                      id: "pLidEditingGezinslidNMTL",
                      label: _vm.labels.gezinsleden.nietMeerTenLaste,
                      info: _vm.infoForGezinsleden("nietMeerTenLaste"),
                      "is-disabled":
                        _vm.disabledFieldsMap.gezinsleden.nietMeerTenLaste,
                      "is-dirty":
                        _vm.$v.currentlyEditingGezinslid.nietMeerTenLaste.$dirty
                    },
                    model: {
                      value: _vm.currentlyEditingGezinslid.nietMeerTenLaste,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.currentlyEditingGezinslid,
                          "nietMeerTenLaste",
                          $$v
                        )
                      },
                      expression: "currentlyEditingGezinslid.nietMeerTenLaste"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("date-input", {
                attrs: {
                  id: "pLidEditingGezinslidOverlijdensdatum",
                  required: _vm.$v.currentlyEditingGezinslid.hasOwnProperty(
                    "required"
                  ),
                  label: _vm.labels.gezinsleden.overlijdensdatum,
                  info: _vm.infoForGezinsleden("overlijdensdatum"),
                  "is-disabled":
                    _vm.disabledFieldsMap.gezinsleden.overlijdensdatum,
                  "is-dirty": false
                },
                model: {
                  value: _vm.currentlyEditingGezinslid.overlijdensdatum,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.currentlyEditingGezinslid,
                      "overlijdensdatum",
                      $$v
                    )
                  },
                  expression: "currentlyEditingGezinslid.overlijdensdatum"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-md-center" }, [
                _c("div", { staticClass: "mr-2" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success btn-sm",
                      attrs: {
                        type: "button",
                        disabled:
                          _vm.$v.currentlyEditingGezinslid.$invalid ||
                          _vm.curEditGezinslidInvalid
                      },
                      on: {
                        click: function($event) {
                          return _vm.completeEditingGezinslid()
                        }
                      }
                    },
                    [_vm._v("\n          Gereed\n        ")]
                  )
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-warning btn-sm",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.cancelEditingGezinslid()
                        }
                      }
                    },
                    [_vm._v("\n          Annuleren\n        ")]
                  )
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "pt-2 mt-3 border-top" }, [
        _c("label", { staticClass: "font-weight-bold" }, [
          _vm._v("Opmerking:")
        ]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.currentRemark,
              expression: "currentRemark"
            }
          ],
          staticClass: "form-control mb-2",
          attrs: { rows: "3", placeholder: "Opmerking", type: "text" },
          domProps: { value: _vm.currentRemark },
          on: {
            input: [
              function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.currentRemark = $event.target.value
              },
              _vm.onRemarkChange
            ]
          }
        })
      ]),
      _vm._v(" "),
      _c("file-upload", {
        attrs: { label: "Bewijsstuk(ken) uploaden:", "upload-percentage": 0 },
        on: { "files-changed": _vm.onFilesChanged }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }